<template>
    <div class="body-panel">
        <div class="form-modal-body">
            <div class="row">
                <b-field style="width: 100%" label="First Name">
                    <b-input v-model="form.first_name" value=""></b-input>
                </b-field>
                <div class="h-spacer"></div>
                <b-field style="width: 100%" label="Last Name">
                    <b-input v-model="form.last_name" value=""></b-input>
                </b-field>
            </div>

            <div class="row">
                <b-field style="width: 100%" label="Phone number">
                    <b-input v-model="form.phone"></b-input>
                </b-field>
                <div class="h-spacer"></div>
                <b-field style="width: 100%" label="Email">
                    <b-input v-model="form.email"></b-input>
                </b-field>
            </div>
            <b-field label="Profile image">
                <upload-trigger :open="false" :enableinput="false" :required="false" :multiple="false"
                    location="assets/uploaded/" :url="$store.state.ASSETS_BASE_URL"
                    :uploadurl="$store.state.BASE_URL + 'upload'" name="main-image" :value="form.image" @onFileSelected="(file) => {
                        form.image = file;
                    }
                        ">
                    <div class="image-upload-widget">Choose Image to upload</div>
                </upload-trigger>
            </b-field>

            <div class="nb">
                Changes will take effect after you save them and signout and sign
                back in.
            </div>
        </div>
        <div class="form-optional-panel">
            <b-button :loading="submit_loading" @click="updateProfile" type="is-primary">UPDATE PROFILE</b-button>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    sockets: {},
    data: () => ({
        form: {
            first_name: "",
            last_name: "",
            image: "",
            phone: "",
            email: "",
        },
        submit_loading: false,
    }),
    watch: {},
    mounted() {
        let vm = this;
        let user = vm.$getLoggedUser().user;
        vm.form.first_name = user.first_name;
        vm.form.last_name = user.last_name;
        vm.form.image = user.profile_image;
        vm.form.phone = user.phone;
        vm.form.email = user.email;
    },
    methods: {
        updateProfile() {
            let vm = this;
            const rules = {
                first_name: {
                    run: (value) => {
                        if (!value) {
                            return "First name can not be empty";
                        }
                        return false;
                    },
                },
                last_name: {
                    run: (value) => {
                        if (!value) {
                            return "Last name can not be empty";
                        }
                        return false;
                    },
                },
                phone: {
                    run: (value) => {
                        if (!value) {
                            return "Phone number can not be empty";
                        }
                        return false;
                    },
                },
                email: {
                    run: (value) => {
                        if (!value) {
                            return "Email can not be empty";
                        }
                        return false;
                    },
                },
            };
            if (vm.$isFieldsValidated(vm.form, rules)) {
                vm.submit_loading = true;
                vm.$store
                    .dispatch("ADMIN_USER_UPDATE_INFO", vm.form)
                    .then((response) => {
                        vm.submit_loading = false;
                        vm.$emit("saved");
                        vm.$notify({
                            group: "status",
                            type: "success",
                            title: "Important message",
                            text: response.data.message,
                        });
                    })
                    .catch(({ response }) => {
                        vm.submit_loading = false;
                        vm.$notify({
                            group: "status",
                            type: "warn",
                            title: "OOPS!!!",
                            text: response.data.message,
                        });
                    });
            }
        },

    },
};
</script>

<style lang="scss" scoped>
.body-panel {
    height: calc(100% - 55px);


    .form-modal-body {
        display: flex;
        flex-direction: column;
        height: calc(100% - 70px);
        padding: 20px;
        overflow-y: auto;

        .nb {
            font-size: 12px;
            color: #999;
            margin-top: 30px;
        }
    }


    .form-optional-panel {
        height: 70px;
        border-top: 1px solid #ddd;
        display: flex;
        align-items: center;
        padding: 0px 20px;
    }
}
</style>